import axiosClient from "../../../../../../api/axiosClient";

const vendorLookupService = {
  search: async (search) => {
    const res = await axiosClient.get(
      `/api/ppe/masters/business-partner/vendors/lookup?search=${search}`
    );
    return res.data || [];
  },
};

export default vendorLookupService;
